@if (viaje) {
  <div class="column-center" style="gap: 3px; width: 100%">
    <div class="row-space-between" style="width: 100%">
      <span
        tooltip="Fin del viaje"
        style="cursor: default; font-size: 16px"
        class="material-icons"
      >
        event
      </span>
      <span>{{ viaje.endTime | date: 'short' }}</span>
    </div>
    @if (viaje.maxSpeed) {
      <div class="row-space-between" style="width: 100%">
        <span
          tooltip="Velocidad Máxima"
          style="cursor: default; font-size: 16px"
          class="material-icons"
        >
          speed
        </span>
        <!-- Tripero devuelve velocidad en km/h -->
        <span>{{ viaje.maxSpeed | number: '1.0-0' }} Km/H</span>
      </div>
    }
    @if (viaje.averageSpeed) {
      <div class="row-space-between" style="width: 100%">
        <span
          tooltip="Velocidad Promedio"
          style="cursor: default; font-size: 16px"
          class="material-icons"
        >
          speed
        </span>
        <!-- Tripero devuelve velocidad en km/h -->
        <span>{{ viaje.averageSpeed | number: '1.0-0' }} Km/H</span>
      </div>
    }

    @if (viaje.distance) {
      <div class="row-space-between" style="width: 100%">
        <span
          tooltip="Distancia recorrida"
          style="cursor: default; font-size: 16px"
          class="material-icons"
        >
          straighten
        </span>
        <span>{{ this.helper.mToKm(viaje.distance, true) }} Km.</span>
      </div>
    }
    @if (viaje.duration) {
      <div class="row-space-between" style="width: 100%">
        <span
          tooltip="Duración del viaje"
          style="cursor: default; font-size: 16px"
          class="material-icons"
        >
          timer
        </span>
        <!-- Tripero devuelve duración en segundos -->
        <span>{{ this.helper.parseSeconds(viaje.duration) }}</span>
      </div>
    }
  </div>
}
